/**
 * Created by Ivan on 28.06.2025
 */

const Room = function (location) {
    cleverapps.EventEmitter.call(this);

    this.location = location;

    this.rewards = {};

    this.roomNo = this.location.getCurrentRoom();

    this.generateConfig();
    this.updateStages();

    location.on("changeStars", this.trigger.bind(this, "changeStars"), this);
    location.on("nextStage", this.updateStage.bind(this), this);
    location.on("beforeNextStage", this.trigger.bind(this, "beforeNextStage"), this);
    location.on("afterNextStage", this.trigger.bind(this, "afterNextStage"), this);
    location.on("reset", this.onReset.bind(this), this);
};

Room.prototype = Object.create(cleverapps.EventEmitter.prototype);
Room.prototype.constructor = Room;

Room.prototype.destructor = function () {
    runCleaners(this);
    this.purge();
};

Room.prototype.generateConfig = function () {
    const stages = this.location.getStagesInBuilding(0);

    const config = [];
    for (let index = 0; index < stages; index++) {
        config.push(index);
    }
    this.config = config;
    this.itemsAmount = stages;

    if (this.location.isLastRoom()) {
        config.push(stages);
        this.itemsAmount++;
    }
};

Room.prototype.updateStages = function () {
    this.stages = cleverapps.arrayFill(this.itemsAmount, 0);

    const fixedStages = this.location.isRoomCompleted()
        ? this.location.getStagesInBuilding(this.location.getCurrentBuilding() - 1)
        : this.location.getCurrentStage();

    for (let i = 0; i < fixedStages; i++) {
        this.stages[this.config[i]]++;
    }
};

Room.prototype.onReset = function () {
    const currentStage = this.location.getCurrentStage();
    for (let i = 0; i < this.stages.length; i++) {
        this.stages[i] = +(i < currentStage);
    }
    this.trigger("reset");
};

Room.prototype.calcCurrentItem = function (isPrevious) {
    const index = this.location.getCurrentStage() - (isPrevious ? 1 : 0);
    return index < this.config.length ? this.config[index] : this.itemsAmount;
};

Room.prototype.calcCurrentStage = function (index) {
    index = index !== undefined ? index : this.location.getCurrentStage();

    if (index === this.stages.length) {
        return 0;
    }

    return this.stages[index];
};

Room.prototype.isLastItem = function (index) {
    return this.location.isLastRoom() && index === this.itemsAmount - 1;
};

Room.prototype.getRewardsForFix = function (stage) {
    if (stage === undefined) {
        stage = this.location.getCurrentStage();
    }

    const rewards = this.location.getRewardsForFix(stage);
    if (!rewards) {
        return;
    }
    
    if (!this.rewards[stage]) {
        this.rewards[stage] = new RewardsList(rewards, {
            toBubbleStack: true,
            event: cleverapps.EVENTS.EARN.FIX_REWARD
        });
    }

    return this.rewards[stage];
};

Room.prototype.updateStage = function (waiter) {
    this.trigger("nextStage", waiter);

    const item = this.calcCurrentItem(true);
    this.stages[item]++;
};

Room.prototype.readyForNext = function () {
    return this.location.isRoomCompleted() && !this.location.isLastRoom();
};

Room.prototype.getBundleId = function () {
    return this.location.getRoomBundleId(this.roomNo);
};